import { Component, Inject } from '@angular/core';
import { GmDashboardService } from '../gm-dashboard.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent {
  cctvCreds: any;
  cctvFrameURL: any
  cctvURL: any;
  
  
  constructor(public campuscctvserviceservice: GmDashboardService, @Inject(MAT_DIALOG_DATA) public data: any,  private domSanitizer: DomSanitizer){}
  ngOnInit(): void {
    console.log("cctv",this.data);
    
    // channelNo
    this.campuscctvserviceservice.getChannel(this.data.cctvDetId, this.data.channelNo).subscribe((res) => {
      this.cctvCreds = res;
      console.log('cctvdetails', this.cctvCreds);
      // const URL = `https://cctvstream.scaits.net/CCTVIndex?cctvDetId=${this.cctvCreds[0].cctvDetId}&buildingId=${this.cctvCreds[0].buildingId}&ipAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&httpPortNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}&rtspPortNo=${this.cctvCreds[0].rtspPortNo}`
      const URL = `https://cctvstream.scaits.net/buildingCctvFrame?buildingId=${this.cctvCreds[0].buildingId}&dvrIPAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&portNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}`
  
      // ${this.cctvCreds[0].cctvStreamingBaseUrl}/
      this.cctvURL = this.domSanitizer.bypassSecurityTrustResourceUrl(URL);
      // this.spinner.hide();
    });
  }
}
